<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HSpu1L/images/cover.jpg?1684305910075" alt="This image is the cover for the book Blood Before Dawn, The Dung Beetles of Liberia series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blood Before Dawn, The Dung Beetles of Liberia series
      </h1>
      <p class="bookDescription body article font2">
        <b>Death of a 130 year Oligarchy.<br/><br/>Volume 2 in The Dung Beetles of Liberia series.</b><br/><br/>In April of 1979, Ken Verrier and his wife, Sam, return to Liberia to buy diamonds. They did not return to get caught up in a rice riot and a coup de'etat. But that's what happens. Ken witnesses and unwittingly participates in a period of Liberia's tumultuous yet poorly documented history---the overthrow of the Tolbert presidency and ultimately the end of the Americo-Liberian one hundred thirty-three years of political and social dominance.<br/><br/>Details of President Tolbert's assassination are sketchy, but through Ken's association with his Americo friends from the past, the CIA agents he meets, and the Liberian military he is forced to deal with, a believable scenario emerges.<b><br/><br/>While describing the once beautiful country and a kind and generous people, Meier intertwines terrifying tales of the atrocities committed that account for the future pain of an entire nation.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel V. Meier Jr.
      </h2>
      
      <p class="authorDescription body article">A retired Aviation Safety Inspector for the FAA, Daniel V. Meier, Jr. has always had a passion for writing. During his college years, he studied history at the University of North Carolina, Wilmington (UNCW) and American Literature at the University of Maryland Graduate School. In 1980 he published an action/thriller with Leisure Books under the pen name of Vince Daniels.<br><br>Dan also worked for the <i>Washington Business Journal</i> as a journalist and has been a contributing writer/editor for several aviation magazines. In addition to <i>Blood Before Dawn,</i> he is the author of its prequel, the award-winning novel, <i>The Dung Beetles of Liberia</i>, as well as two other highly acclaimed novels published by BQB Publishing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Boutique of Quality Books Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b0313ece